import { Component, OnInit } from '@angular/core';
import { CardToken, CardTokenQuery } from '@fgb/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'fgb-payment-button',
  templateUrl: './payment-button.component.html',
  styleUrl: './payment-button.component.scss',
})
export class PaymentButtonComponent implements OnInit {
  cardToken$: Observable<CardToken | undefined>;

  constructor(private cardTokenQuery: CardTokenQuery) {}

  ngOnInit(): void {
    this.cardToken$ = this.cardTokenQuery.selectDefaultCard();
  }
}
